import { RegisterOptions } from 'react-hook-form'
import { FormValues } from '.'
import { stripSpaces } from '../../utils'

export const errorMessages = {
  required: 'Please enter your right to rent share code.',
  length: 'Your right to rent share code must be exactly 9 characters.',
  invalid: 'Please enter a valid right to rent share code.',
}

const SHARE_CODE_LENGTH = 9

const validCodeRegex = /^R[A-Za-z0-9]{8}$/

export const sharecodeValidationRules: RegisterOptions<FormValues, 'rightToRentCode'> = {
  required: errorMessages.required,
  validate: {
    length: val => stripSpaces(val).length === SHARE_CODE_LENGTH || errorMessages.length,
    format: val => validCodeRegex.test(stripSpaces(val)) || errorMessages.invalid,
  },
}
